import { connect } from 'react-redux';
import React from 'react';
import { KBFormError, KBButton, KBPopoverTop } from 'components';
import LocationProviderForm from './LocationProviderForm';
import { KBNoData } from 'components';
import { api } from 'app/services';
import { reduxForm } from 'redux-form';
import { withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { showApiSuccess, showApiError } from 'utils/feedback';

var LocationProviderSetForm = class extends React.Component {constructor(props) {super(props);this.addProviderField = this.addProviderField.bind(this);this.providerField = this.providerField.bind(this);this.providerFieldUpdate = this.providerFieldUpdate.bind(this);this.addLocationProvider = this.addLocationProvider.bind(this);this.updateLocationProvider = this.updateLocationProvider.bind(this);this.updateLocationProviders = this.updateLocationProviders.bind(this);}componentDidMount()

  {
    const {
      change,
      groups_id } =
    this.props;
    api.getGroupProviders({ location_group_id: groups_id }).then(res => {
      const { json } = res;
      if (json && Array.isArray(json)) {
        change('location_providers', json.map(item => this.addProviderField(item)));
      }
    });
    // location.location_providers &&
    //   location.location_providers.length > 0 &&
    //   location.location_providers.map(provider => {
    //     location_providers.addField(this.addProviderField(provider))
    //   })
  }addProviderField(

  provider) {
    return {
      id: provider.id,
      info: provider.info,
      contact_name: provider.contact_name,
      contact_phone: provider.contact_phone,
      contact_email: provider.contact_email,
      account_bank: provider.account_bank,
      account_name: provider.account_name,
      account_number: provider.account_number,
      physical_address: provider.physical_address,
      business_license_number: provider.business_license_number,
      swift_code: provider.swift_code };

  }providerField(

  provider) {
    const {
      fields: { location_providers } } =
    this.props;
    location_providers.addField({
      info: provider.info,
      contact_name: provider.contact_name,
      contact_phone: provider.contact_phone,
      contact_email: provider.contact_email,
      account_bank: provider.account_bank,
      account_name: provider.account_name,
      account_number: provider.account_number,
      physical_address: provider.physical_address,
      business_license_number: provider.business_license_number,
      swift_code: provider.swift_code,
      modified: true });

  }providerFieldUpdate(

  provider, index) {
    const {
      fields: { location_providers } } =
    this.props;
    location_providers[index].info.onChange(provider.info);
    location_providers[index].contact_name.onChange(provider.contact_name);
    location_providers[index].contact_phone.onChange(provider.contact_phone);
    location_providers[index].contact_email.onChange(provider.contact_email);
    location_providers[index].account_bank.onChange(provider.account_bank);
    location_providers[index].account_name.onChange(provider.account_name);
    location_providers[index].account_number.onChange(provider.account_number);
    location_providers[index].physical_address.onChange(
    provider.physical_address);

    location_providers[index].business_license_number.onChange(
    provider.business_license_number);

    location_providers[index].swift_code.onChange(provider.swift_code);
    location_providers[index].modified.onChange(true);
  }addLocationProvider()

  {
    KBPopoverTop.show(<LocationProviderForm callBack={this.providerField} />);
  }updateLocationProvider(

  provider, index) {
    KBPopoverTop.show(
    <LocationProviderForm
    provider={provider}
    index={index}
    callBack={this.providerFieldUpdate} />);


  }updateLocationProviders(

  model) {
    const {
      change,
      groups_id } =
    this.props;
    let newProviders = (model.location_providers || []).map(pro => {
      const { modified, ...provider } = pro;
      return provider;
    });
    api.undateGroupProviders({ location_group_id: groups_id, location_providers: newProviders }).then(res => {

      const { json } = res;
      if (json && Array.isArray(json)) {
        change('location_providers', json.map(item => this.addProviderField(item)));
        showApiSuccess('保存成功');
      } else {
        showApiError('保存失败');
      }
    });
    // return (
    //   updateLocation && updateLocation({ location_providers: newProviders })
    // )
  }render()

  {
    const {
      fields: { location_providers },
      error,
      submitting,
      handleSubmit } =
    this.props;
    return (
      <form onSubmit={handleSubmit(this.updateLocationProviders)}>
        <KBFormError err={error} />
        <fieldset className="fieldset">
          <div
          className="kb-title m-bottom-sm"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between' }}>


            <span>收款账户信息(银行)</span>
            <div className="bordered-btn" onClick={this.addLocationProvider}>
              添加账户信息
            </div>
          </div>
          {location_providers.length > 0 ?
          <div>
              {location_providers.map((provider, index) => {
              const modified = provider.modified.value;
              const providerKey = provider.id && provider.id.value ? provider.id.value : index;
              return (
                <div key={providerKey} className="location-provider-container">
                    {modified ?
                  <div className="tip-msg">
                        <div className="icon">
                          <i className="iconfont icon-hint" />
                        </div>
                        <div>
                          请点击下方“保存”按钮以确认保存当前收款账户信息
                        </div>
                      </div> :
                  null}
                    <div
                  className="location-provider"
                  style={modified ? { border: '1px dashed #DFE4E7' } : {}}>

                      <span
                    className="operate-provider delete-provider"
                    onClick={() => {
                      location_providers.removeField(index);
                    }}>

                        <i className="iconfont icon-delete" />
                      </span>
                      <span
                    className="operate-provider update-provider"
                    onClick={this.updateLocationProvider.bind(
                    null,
                    provider,
                    index)}>


                        <i className="iconfont icon-edit" />
                      </span>
                      <div className="provider-line">
                        <div>
                          <span>账户信息</span>
                          <span>{provider.info.value || '暂无'}</span>
                        </div>
                      </div>
                      <div className="provider-line">
                        <div>
                          <span>账户开户行</span>
                          <span>{provider.account_bank.value || '暂无'}</span>
                        </div>
                        <div>
                          <span>账户地址</span>
                          <span>
                            {provider.physical_address.value || '暂无'}
                          </span>
                        </div>
                      </div>
                      <div className="provider-line">
                        <div>
                          <span>账户名</span>
                          <span>{provider.account_name.value || '暂无'}</span>
                        </div>
                        <div>
                          <span>账号</span>
                          <span>{provider.account_number.value || '暂无'}</span>
                        </div>
                      </div>
                      <div className="provider-line">
                        <div>
                          <span>联系人</span>
                          <span>{provider.contact_name.value || '暂无'}</span>
                        </div>
                        <div>
                          <span>联系方式</span>
                          <span>{provider.contact_phone.value || '暂无'}</span>
                        </div>
                      </div>
                      <div className="provider-line">
                        <div>
                          <span>统一社会信用代码</span>
                          <span>
                            {provider.business_license_number &&
                          provider.business_license_number.value ||
                          '暂无'}
                          </span>
                        </div>
                        <div>
                          <span>SWIFT代码</span>
                          <span>
                            {provider.swift_code &&
                          provider.swift_code.value ||
                          '暂无'}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>);

            })}
            </div> :

          <KBNoData tipMessage="暂无账户信息" />}

        </fieldset>
        <div className="kb-row">
          <KBButton
          className="certain-btn"
          type="submit"
          submitting={submitting}>

            保存
          </KBButton>
        </div>
      </form>);

  }};


const validate = values => {
  const errors = {};

  return errors;
};

function mapStateToProps(state, props) {
  return {};
}

const LEGACY_FORM_FIELDS = [
  "location_providers[].info",
  "location_providers[].contact_name",
  "location_providers[].contact_phone",
  "location_providers[].contact_email",
  "location_providers[].account_bank",
  "location_providers[].account_name",
  "location_providers[].account_number",
  "location_providers[].physical_address",
  "location_providers[].id",
  "location_providers[].modified",
  "location_providers[].business_license_number",
  "location_providers[].swift_code"
];

const formConfig = {
  form: 'LocationProviderSetForm',

  validate: validate,
  touchOnBlur: false };


export default connect(mapStateToProps)(reduxForm(formConfig)(withReduxFormFieldProps('LocationProviderSetForm', LEGACY_FORM_FIELDS)(LocationProviderSetForm)));
